'use es6';

import registerBasicData from './registerBasicData';
import '../../moment/moment-and-timezone-init';
import '../../moment/standardMomentLocales';
import '../../moment/publicMomentLocales';
export default (Provider => {
  return registerBasicData(Provider);
});